const couponRedemptionsKeys = {
  module: ['couponRedemptions'] as const,
  list: () => [...couponRedemptionsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...couponRedemptionsKeys.list(), filters] as const,
  details: (id: string) =>
    [...couponRedemptionsKeys.module, 'details', id] as const,
};

export default couponRedemptionsKeys;
